import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import Divider from "@mui/material/Divider";
import LogoutIcon from "@mui/icons-material/Logout";
import useCurrentRole from "../hooks/useCurrentRole";
import useLogout from "../hooks/useLogout";

interface AuthorizedNavigationItemProps {
  path: string;
  allowedRoles: string[];
  children: React.ReactNode;
}

function AuthorizedNavigationItem({
  path,
  allowedRoles,
  children,
}: AuthorizedNavigationItemProps) {
  const role = useCurrentRole();
  if (!role || !allowedRoles.includes(role)) {
    return null;
  }
  return (
    <ListItem>
      <ListItemButton component={Link} to={path}>
        {children}
      </ListItemButton>
    </ListItem>
  );
}
const MainMenu = () => {
  const doLogout = useLogout();
  return (
    <Box sx={{ mt: 7 }}>
      <List>
        <AuthorizedNavigationItem
          path="/admin/record"
          allowedRoles={["user", "su"]}
        >
          <ListItemText>Make Recording</ListItemText>
        </AuthorizedNavigationItem>
        <AuthorizedNavigationItem
          path="/admin/recordings"
          allowedRoles={["trn", "su"]}
        >
          <ListItemText>Recordings</ListItemText>
        </AuthorizedNavigationItem>
        <AuthorizedNavigationItem
          path="/admin/site-notes"
          allowedRoles={["trn", "su", "smgr"]}
        >
          Site Notes
        </AuthorizedNavigationItem>
        <AuthorizedNavigationItem
          path="/admin/create-user"
          allowedRoles={["su"]}
        >
          <ListItemText>Create User</ListItemText>
        </AuthorizedNavigationItem>
        <AuthorizedNavigationItem
          path="/admin/review-visits"
          allowedRoles={["su"]}
        >
          <ListItemText>Review Visits</ListItemText>
        </AuthorizedNavigationItem>

        <Divider />
        <ListItem>
          <ListItemButton onClick={doLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </ListItem>

        {/* <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <EventIcon />
            </ListItemIcon>
            <ListItemText>
              <ThemedNavLink to="visits">
                <FormattedMessage id="visits" />
              </ThemedNavLink>
            </ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <BarChartIcon />
            </ListItemIcon>
            <ListItemText>
              <ThemedNavLink to="data">
                <FormattedMessage id="data" />
              </ThemedNavLink>
            </ListItemText>
          </ListItemButton>
        </ListItem> */}
      </List>
    </Box>
  );
};

export default MainMenu;
